import { Card, CardBody, Col } from "reactstrap";
import StockResultCardHeader from "./StockResultCardHeader";
import { STOCK_RESULT_COLUMN, STOCK_RESULT_DATA } from "../../../../Data/DataTable/StockResultData";
import DataTable from "react-data-table-component";

const StockResult = () => {
  return (
    <Col sm="12">
      <Card>
        <StockResultCardHeader />
        <CardBody>
          <div className="table-responsive theme-scrollbar">
            <div id="stock_wrapper" className="dataTables_wrapper">
              <DataTable data={STOCK_RESULT_DATA} columns={STOCK_RESULT_COLUMN} striped fixedHeader fixedHeaderScrollHeight="50vh" className="display dataTable" />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StockResult;
